import React from 'react';
import Flex from 'toolbox/src/components/Flex/Flex';
import { addComponentSeparator } from 'toolbox';
import { NavLink } from 'react-router-dom';
import HeroIconCheveronRight from 'toolbox/src/components/HeroIcons/HeroIconCheveronRight';

interface BreadcrumbsProps {
  links: { label: string | undefined; link?: string; props?: any }[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ links }) => {
  return (
    <Flex mx={1} alignItems="center">
      {addComponentSeparator(
        links.map(({ label, link, ...props }, i) => {
          if (link) {
            return (
              <NavLink
                {...props}
                key={i}
                to={link}
                className="text-base font-semibold text-jcap-500"
              >
                {label}
              </NavLink>
            );
          }
          return (
            <p
              {...props}
              className="text-base font-semibold text-gray-600"
              key={i}
            >
              {label}
            </p>
          );
        }),
        (key: string) => (
          <HeroIconCheveronRight key={key} className="text-gray-500" />
        ),
      )}
    </Flex>
  );
};

export default Breadcrumbs;
